import { $ } from "../shared/globals.js";

export function createBrandTigerScrollWalkFeature({ CONFIG, prefersReducedMotion }) {
    const $brandWalk = $(".main-brand-walk");
    const $brandStatic = $brandWalk.find(".main-brand-static");
    const $brandFrames = $brandWalk.find(".main-brand-frame");
    const totalFrames = Math.min(CONFIG.tigerWalkFrames, $brandFrames.length);
    const pixelsPerFrame = CONFIG.brandTigerScrollPixelsPerFrame;
    const activationDistance = CONFIG.brandTigerScrollActivationDistance;

    let initialized = false;
    let lastScrollTop = 0;
    let progress = 0;
    let currentFrame = 1;
    let pendingDelta = 0;
    let activationDelta = 0;
    let rafId = null;
    let isArmed = false;
    let hasActivated = false;

    function getScrollTop() {
        return Math.max(window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0, 0);
    }

    function showStatic() {
        $brandFrames.removeClass("active");
        $brandStatic.addClass("active");
    }

    function showFrame(frameNumber) {
        $brandStatic.removeClass("active");
        $brandFrames.removeClass("active");
        $brandWalk.find(`.main-brand-frame-${frameNumber}`).addClass("active");
    }

    function syncFrame() {
        const frameProgress = progress >= 0 ? Math.floor(progress) : Math.ceil(progress);
        const normalizedIndex = ((frameProgress % totalFrames) + totalFrames) % totalFrames;
        const nextFrame = normalizedIndex + 1;

        if (nextFrame === currentFrame) return;

        currentFrame = nextFrame;
        showFrame(currentFrame);
    }

    function armFromKeyboard(event) {
        const scrollKeys = ["ArrowDown", "ArrowUp", "PageDown", "PageUp", "Home", "End", "Space"];

        if (scrollKeys.includes(event.code) || scrollKeys.includes(event.key)) {
            isArmed = true;
        }
    }

    function flushPendingDelta() {
        rafId = null;

        if (!pendingDelta) return;

        if (!hasActivated) {
            activationDelta += pendingDelta;
            pendingDelta = 0;

            if (Math.abs(activationDelta) < activationDistance) {
                return;
            }

            hasActivated = true;
            progress += activationDelta / pixelsPerFrame;
            activationDelta = 0;
            showFrame(currentFrame);
            syncFrame();
            return;
        }

        progress += pendingDelta / pixelsPerFrame;
        pendingDelta = 0;
        syncFrame();
    }

    function onScroll() {
        const scrollTop = getScrollTop();
        const delta = scrollTop - lastScrollTop;
        lastScrollTop = scrollTop;

        if (!isArmed || !delta) {
            return;
        }

        pendingDelta += delta;

        if (!rafId) {
            rafId = window.requestAnimationFrame(flushPendingDelta);
        }
    }

    function start() {
        if (initialized || !$brandWalk.length) return;

        initialized = true;

        if (prefersReducedMotion || !totalFrames) {
            showStatic();
            return;
        }

        lastScrollTop = getScrollTop();
        currentFrame = 1;
        progress = 0;
        pendingDelta = 0;
        activationDelta = 0;
        isArmed = false;
        hasActivated = false;
        showStatic();

        $(window).on("scroll.brand-tiger-walk", onScroll);
        $(window).on("wheel.brand-tiger-walk touchstart.brand-tiger-walk pointerdown.brand-tiger-walk", () => {
            isArmed = true;
        });
        $(window).on("keydown.brand-tiger-walk", armFromKeyboard);
    }

    function stop() {
        if (!initialized) return;

        $(window).off("scroll.brand-tiger-walk");
        $(window).off("wheel.brand-tiger-walk touchstart.brand-tiger-walk pointerdown.brand-tiger-walk");
        $(window).off("keydown.brand-tiger-walk", armFromKeyboard);

        if (rafId) {
            window.cancelAnimationFrame(rafId);
            rafId = null;
        }

        initialized = false;
        pendingDelta = 0;
        activationDelta = 0;
        progress = 0;
        currentFrame = 1;
        isArmed = false;
        hasActivated = false;
        showStatic();
    }

    return {
        start,
        stop,
    };
}
